// An aggregate HOC provider to avoid the need to deeply nest entity data providers.
import * as React from 'react';
/* @ts-ignore */
export var EntityDataProviders = function (_a) {
  var items = _a.items,
    children = _a.children;
  return items.reduce(function (acc, Provider) {
    return React.createElement(Provider, null, acc);
  }, children);
};